<template>
  <div>
<!--    TODO: THIS DIV BELOW IS TO BE USED WITH THE MODAL-->
<!--    <div class="wrapper presentation-page" :class="{'is-valid-code' : !validCode}">-->
    <div class="wrapper presentation-page">
      <div id="about-sun-king" class="section section-content" data-background-color="black">
        <div class="container">
          <div class="row swapcolumns">
            <div class="col-md-6">
              <div class="image-container">
                <img class="img img-raised rounded img-comments rellax hide-text" data-rellax-speed="1"
                     src="img/chad/edits-15.jpg" alt="chad-ashe-15">
                <img class="img img-raised rounded img-blog rellax" data-rellax-speed="4"
                     src="img/chad/edits-39.jpg" alt="content 4">
              </div>
            </div>
            <div class="col-md-6 ml-auto mr-auto">
              <div class="section-description">
                <h2 class="title">{{ $t('moreAboutChad') }}</h2>
                <h5 class="description">
                  {{ $t('aboutDescription1') }}
                  <br>
                  <br>
                  {{ $t('aboutDescription2') }}
                  <br>
                  <br>
                  {{ $t('aboutDescription3') }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
<!--      <div id="photos" class="section related-products">-->
<!--        <div class="container">-->
<!--          <div class="col-md-8 mr-auto ml-auto text-center">-->
<!--            <h2 class="title">{{ $t('pressTitle') }}</h2>-->
<!--          </div>-->
<!--          <div class="row">-->
<!--            <div class="col-sm-6 col-md-3">-->
<!--              <card type="product">-->
<!--                <a href="img/chad/edits-8.jpg" download="ChadAshe-press-photo1">-->
<!--                  <img slot="image" class="img rounded" src="img/chad/edits-8.jpg"/>-->
<!--                </a>-->
<!--              </card>-->
<!--            </div>-->
<!--            <div class="col-sm-6 col-md-3">-->
<!--              <card type="product">-->
<!--                <a href="img/chad/edits-41.jpg" download="ChadAshe-press-photo2">-->
<!--                  <img slot="image" class="img rounded" src="img/chad/edits-41.jpg"/>-->
<!--                </a>-->
<!--              </card>-->
<!--            </div>-->
<!--            <div class="col-sm-6 col-md-3">-->
<!--              <card type="product">-->
<!--                <a href="img/chad/edits-44.jpg" download="ChadAshe-press-photo3">-->
<!--                  <img slot="image" class="img rounded" src="img/chad/edits-44.jpg"/>-->
<!--                </a>-->
<!--              </card>-->
<!--            </div>-->
<!--            <div class="col-sm-6 col-md-3">-->
<!--              <card type="product">-->
<!--                <a href="img/chad/edits-15.jpg" download="ChadAshe-press-photo4">-->
<!--                  <img slot="image" class="img rounded" src="img/chad/edits-15.jpg"/>-->
<!--                </a>-->
<!--              </card>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div id="news-article" class="blogs-5 section section-image" style="background-image: url('img/chad/edits-29.jpg')">-->
<!--        <div class="container">-->
<!--          <div class="row">-->
<!--            <div class="col-md-12 ml-auto mr-auto">-->
<!--              <h2 class="title">News Articles</h2>-->
<!--              <div class="row">-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://globalnews.ca/news/8417802/montreal-area-teacher-rap-video-to-be-reinstated/">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/global-news-logo.png">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://globalnews.ca/news/8417802/montreal-area-teacher-rap-video-to-be-reinstated/">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b> Global News</b>-->
<!--                        </h5>-->
<!--                        Montreal-area teacher suspended because of rap video to be reinstated.-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://www.tvanouvelles.ca/2021/12/01/le-prof-rappeur-de-chateauguay-pourra-reprendre-ses-cours">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/tva-logo.png">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://www.tvanouvelles.ca/2021/12/01/le-prof-rappeur-de-chateauguay-pourra-reprendre-ses-cours">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b>TVA Nouvelles</b>-->
<!--                        </h5>-->
<!--                        Le prof rappeur de Châteauguay pourra reprendre ses cours-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://www.journaldemontreal.com/2021/11/30/suspension-annulee-pour-le-prof-rappeur-de-chateauguay">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/journal-montreal-logo.png">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://www.journaldemontreal.com/2021/11/30/suspension-annulee-pour-le-prof-rappeur-de-chateauguay">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b>Jounal de Montreal</b>-->
<!--                        </h5>-->
<!--                        Le prof rappeur de Châteauguay pourra reprendre ses cours.-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://www.lecourrierdusud.ca/un-enseignant-suspendu-pour-son-videoclip-de-hip-hop/">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/courrier-du-sud-logo.png">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://www.lecourrierdusud.ca/un-enseignant-suspendu-pour-son-videoclip-de-hip-hop/">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b>Le courrier du Sud</b>-->
<!--                        </h5>-->
<!--                          Un enseignant suspendu pour son vidéoclip de hip-hop.-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://www.cybersoleil.com/teacher-suspended-by-new-frontiers-will-return-to-work/?fbclid=IwAR0K022piFS9ftGgb0ddesiX-KszKhCnfqIJ4w6iscJmbQ6aqhmCn_7Ptuc">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/soleil-chateaugay-logo.png">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://www.cybersoleil.com/teacher-suspended-by-new-frontiers-will-return-to-work/?fbclid=IwAR0K022piFS9ftGgb0ddesiX-KszKhCnfqIJ4w6iscJmbQ6aqhmCn_7Ptuc">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b>Le Soleil de Chateaugay</b>-->
<!--                        </h5>-->
<!--                        Teacher suspended by New Frontiers will return to work.                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://www.cybersoleil.com/l-enseignant-suspendu-par-New-Frontiers-retournera-au-travail/">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/soleil-chateaugay-logo.png">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://www.cybersoleil.com/l-enseignant-suspendu-par-New-Frontiers-retournera-au-travail/">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b>Le Soleil de Chateaugay</b>-->
<!--                        </h5>-->
<!--                        L’enseignant suspendu par New Frontiers retournera au travail.-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://montreal.ctvnews.ca/montreal-area-teacher-suspended-over-showing-his-hip-hop-music-video-to-students-allowed-to-teach-again-1.5693352">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/ctv-news-logo.png">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://montreal.ctvnews.ca/montreal-area-teacher-suspended-over-showing-his-hip-hop-music-video-to-students-allowed-to-teach-again-1.5693352">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b>CTV News</b>-->
<!--                        </h5>-->
<!--                        Montreal-area teacher suspended over showing his hip hop music video to students allowed to teach again.                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://www.qub.ca/article/un-prof-suspendu-pour-un-videoclip-1061298175">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/qub-logo.png">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://www.qub.ca/article/un-prof-suspendu-pour-un-videoclip-1061298175">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b>QUB</b>-->
<!--                        </h5>-->
<!--                        Un prof suspendu pour un vidéoclip.-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://selonwalter.com/prof-suspendu-pour-son-videoclip-stereotypes-dun-homme-noir-mal-compris/?fbclid=IwAR3VfD03fm_9Xt1Zcoemw766oGbHdGrXkDcNFFxjEprzEEvA8DihyU2Z2Bw">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/walter-logo.png">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://selonwalter.com/prof-suspendu-pour-son-videoclip-stereotypes-dun-homme-noir-mal-compris/?fbclid=IwAR3VfD03fm_9Xt1Zcoemw766oGbHdGrXkDcNFFxjEprzEEvA8DihyU2Z2Bw">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b>Selon Walter</b>-->
<!--                        </h5>-->
<!--                        Prof suspendu pour son vidéoclip : stéréotypes d’un homme noir mal compris.-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://cfcnews.com/326271/">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/cfc-logo.png">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://cfcnews.com/326271/">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b>Come From China</b>-->
<!--                        </h5>-->
<!--                        蒙特利尔地区一位酷爱嘻哈艺术的高中老师因为制作了一段说唱视频被家长投诉，目前他已被学校停职。他认为自己被停职不仅“令人发指”，而且这可能是出于种族歧视的动机。-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-3">-->
<!--                  <div class="card card-blog news-card">-->
<!--                    <div class="card-image">-->
<!--                      <a href="https://montreal.citynews.ca/2021/12/01/quebec-teacher-suspended-bathing-suit/">-->
<!--                        <img class="img rounded news-card-img" src="img/chad/press/city-news-logo.jpg">-->
<!--                      </a>-->
<!--                    </div>-->
<!--                    <div class="card-body">-->
<!--                      <a href="https://montreal.citynews.ca/2021/12/01/quebec-teacher-suspended-bathing-suit/">-->
<!--                        <h5 class="card-title text_bold">-->
<!--                          <b>City News</b>-->
<!--                        </h5>-->
<!--                        Quebec teacher allegedly suspended for being in bathing suit in music video.-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div id="snippet" class="features-7 section-image cards">-->
<!--        <div class="col-md-8 mr-auto ml-auto text-center">-->
<!--          <h2 class="title">Snippet of future song</h2>-->
<!--          &lt;!&ndash;            <h4 class="description">This is the paragraph where you can write more details about your product. Keep you user engaged by providing meaningful information.</h4>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="container-fluid">-->
<!--          <div class="row" >-->
<!--            <div class="col-md-6 px-0">-->
<!--              <div class="card card-fashion card-background" style="background-image: url('img/chad/WAHALA-CHAD-ASHE.jpg')">-->
<!--                <div class="card-body">-->
<!--                  <div class="card-title text-left">-->
<!--                    <h4>-->
<!--                      <a href="#pablo">-->
<!--                        Wahala - Chad Ashe-->
<!--                      </a>-->
<!--                    </h4>-->
<!--                  </div>-->
<!--                  <div class="card-footer text-left">-->
<!--                    <Countdown deadline="August 22, 2022"></Countdown>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-md-6 px-0">-->
<!--              <div class="card-container" style="margin-top: 0px; width: 100%;">-->
<!--                <div class="card card-fashion">-->
<!--                  <h4 class="card-title">-->
<!--                    <b-link @click.native="modals.notice = true">-->
<!--                      Click here to view lyrics.-->
<!--                    </b-link>-->
<!--                  </h4>-->
<!--                </div>-->
<!--                <div class="card card-fashion card-background"-->
<!--                     style="background-image: url('https:///mvpwp.com/demo/nowwp/wp-content/uploads/sites/6/2017/06/a-james-donovan-180375.jpg')">-->

<!--                  <div class="info info-horizontal">-->
<!--                      <div class="description text-center justify-content-center" style="margin-top: 150px;">-->
<!--                        <a href="https://soundcloud.com/houseofashes51450" target="_blank" rel="noopener noreferrer">-->
<!--                          <h4 class="info-title text-white">Stream now on Soundcloud</h4>-->
<!--                          <span class="iconify" data-icon="fa-brands:soundcloud" data-width="100" data-height="100"></span>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                  </div>-->

<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div id="latest-songs" class="team-2 section section-image" style="background-image: url('img/chad/edits-10.jpg')">-->
<!--        <div class="container">-->
<!--        <div class="col-md-8 ml-auto mr-auto text-center">-->
<!--          <h2 class="title">Snippet of future songs</h2>-->
<!--        </div>-->
<!--          <div class="row">-->
<!--            <div class="col-md-10" style="margin-left: auto;margin-right: auto;">-->
<!--            <iframe width="100%" height="500" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1360135189%3Fsecret_token%3Ds-LgxKcDPi0dd&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>-->
<!--              <div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;">-->
<!--                <a href="https://soundcloud.com/houseofashes51450" title="Chad Ashe" target="_blank" style="color: #cccccc; text-decoration: none;">-->
<!--                  Chad Ashe-->
<!--                </a> ·-->
<!--                <a href="https://soundcloud.com/houseofashes51450/sets/future-single-release/s-LgxKcDPi0dd" title="FSR" target="_blank" style="color: #cccccc; text-decoration: none;">-->
<!--                  FSR</a>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div id="download" class="features-7 section-image" data-background-color="gray">-->
<!--        <div class="col-md-8 mr-auto ml-auto text-center">-->
<!--          <h2 class="title">Download links</h2>-->
<!--          &lt;!&ndash;            <h4 class="description">This is the paragraph where you can write more details about your product. Keep you user engaged by providing meaningful information.</h4>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="container-fluid">-->
<!--          <div class="row">-->
<!--            <div class="col-sm-12">-->
<!--              <div class="row">-->
<!--                <div class="col-md-6">-->
<!--                  <div class="info info-horizontal">-->
<!--                    <div class="description text-center">-->
<!--                      <a href="https://music.apple.com/ca/artist/chad-ashe/id1517895366" target="_blank" rel="noopener noreferrer">-->
<!--                        <h5 class="info-title">Music For Press</h5>-->
<!--                        <div class="row">-->
<!--                          <div class="col-md-6 col-lg-8 ml-auto mr-auto text-center">-->
<!--                            <n-button size="lg" round>Download</n-button>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-6">-->
<!--                  <div class="info info-horizontal">-->
<!--                    <div class="description text-center">-->
<!--                      <a href="https://music.amazon.ca/artists/B003Y67GXG/chad-ashe?marketplaceId=A2EUQ1WTGCTBG2&musicTerritory=CA&ref=dm_sh_YNE0U3EYLGHAwNSNZIurdbuES" target="_blank" rel="noopener noreferrer">-->
<!--                        <h5 class="info-title">Mixes For DJs'</h5>-->
<!--                        <div class="row">-->
<!--                          <div class="col-md-6 col-lg-8 ml-auto mr-auto text-center">-->
<!--                            <n-button size="lg" round>Download</n-button>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash;                <div class="col-md-6">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <div class="image-container">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <img v-lazy="'img/chad/edits-14.jpg'" alt="chad-ashe-press-photo">&ndash;&gt;-->
<!--            &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div id="mailing" class="section section-basic-components" style="padding:0px;" data-background-color="gray">-->
<!--        <div class="container">-->
<!--          <div class="row">-->
<!--            <div class="col-lg-5 col-md-7 ml-auto mr-auto" style="color:black; ">-->
<!--              <h2 class="title">Subscribe to mailing list</h2>-->
<!--              <div class="row">-->
<!--                <div class="col-lg-12 col-md-12">-->
<!--                  <div class="row">-->
<!--                    <div class="col-sm-8 col-lg-10 ml-auto mr-auto">-->
<!--                      <fg-input addon-left-icon="now-ui-icons users_single-02"-->
<!--                                placeholder="Enter your email" size="lg">-->
<!--                      </fg-input>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="row">-->
<!--                    <div class="col-md-6 col-lg-8 ml-auto mr-auto text-center">-->
<!--                      <n-button size="lg" round>Subscribe</n-button>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="col-lg-6 col-md-12">-->
<!--              <div class="image-container hide-text">-->
<!--                <img class="components-macbook" src="img/chad/edits-5.jpg" alt="ipad_img">-->
<!--                &lt;!&ndash;                  <img class="chad-responsive-img-1" src="img/chad/snak-chad-ashe.jpg" alt="table">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <img class="chad-responsive-img-2" src="img/chad/WAHALA-CHAD-ASHE.jpg" alt="share button">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <img class="chad-responsive-img-3" src="img/chad/edits-58.jpg" alt="coloured card with button">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <img class="chad-responsive-img-4" src="img/chad/edits-16.jpg" alt="coloured card">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <img class="chad-responsive-img-5" src="img/chad/edits-10.jpg" alt="social row">&ndash;&gt;-->
<!--                &lt;!&ndash;                  <img class="chad-responsive-img-6" src="img/chad/edits-29.jpg"&ndash;&gt;-->
<!--                &lt;!&ndash;                       alt="linked in button">&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <footer class="footer footer-white">
        <div class="container">
          <a class="footer-brand" href="/">
            <div style="height: 30px; width: 30px; margin: auto;">
              <img src="img/chad/chad-ashe-logo.png" alt="chad ashe logo">
            </div>
            Chad Ashe
          </a>
          <ul class="pull-center">
            <li>
              <router-link :to="{ path: `/about` }" class="nav-link">
                {{ $t('about') }}
              </router-link>
            </li>
            <li>
              <a href="/#videos" class="nav-link">
                {{ $t('videos') }}
              </a>
            </li>
            <li>
              <a href="/#interviews" class="nav-link">
                {{ $t('interviews') }}
              </a>
            </li>
            <li>
              <a href="/#music" class="nav-link">
                {{ $t('music') }}
              </a>
            </li>
            <li>
              <a href="/#photos" class="nav-link">
                {{ $t('photos') }}
              </a>
            </li>
            <li>
              <a href="/#contact" class="nav-link">
                {{ $t('contact') }}
              </a>
            </li>
          </ul>
          <ul class="social-buttons pull-right">
            <li>
              <a href="https://twitter.com/CreativeTim" target="_blank"
                 class="btn btn-icon btn-neutral btn-facebook">
                <i class="fab fa-facebook"></i>
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/CreativeTim" target="_blank"
                 class="btn btn-icon btn-neutral btn-instagram">
                <i class="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/CreativeTimOfficial" target="_blank"
                 class="btn btn-icon btn-neutral btn-google">
                <i class="fab fa-google-plus"></i>
              </a>
            </li>
          </ul>
        </div>
      </footer>

<!--      &lt;!&ndash; notice modal &ndash;&gt;-->
<!--      <modal :show.sync="modals.notice"-->
<!--             footerClasses="justify-content-center"-->
<!--             type="notice">-->
<!--        <h5 slot="header" class="modal-title">Wahala - Chad Ashe</h5>-->
<!--        <template>-->
<!--          <div class="instruction">-->
<!--            <div class="row">-->
<!--              <div class="col-md-12" style="white-space: pre-wrap;">-->
<!--                Baby can I taste your sugar-->
<!--                You are looking like my type right now-->
<!--                I don't want to stress things out-->
<!--                Baby tell me what you are about-->
<!--                Ain't no need to pretend-->
<!--                I only want to be your friend-->
<!--                And we can have fun until the end-->
<!--                Cause by the end of night by the end of this song-->
<!--                At the end of your life when everyone is gone-->
<!--                I'm a still care for you-->
<!--                Still ride for you-->
<!--                Live and die by you-->
<!--                Baby that's the truth cause-->
<!--                I don't want wahala-->
<!--                I just want to holla-->
<!--                And spend money in Nevada-->
<!--                Then get faded in Jamaica-->
<!--                Dance on me like passa passa-->
<!--                Honey you a keeper-->
<!--                I think I want to keep you-->
<!--                But I don't want wahala-->
<!--                I don't want wahala-->
<!--                I just want to holla-->
<!--                And spend money in Nevada-->
<!--                Then get faded in Jamaica-->
<!--                Dance on me like passa passa-->
<!--                Honey you a keeper-->
<!--                I think I want to keep you-->
<!--                But I don't want wahala-->
<!--                I don't want wahala but you looking like the devil in Prada-->
<!--                And I got a taste for danger so baby can I taste your sugar-->
<!--                Dance like you want me-->
<!--                Dance like you need me-->
<!--                Cause I haven't had a bubble in a long long time-->
<!--                Baby come here and give me strong wine-->
<!--                Dance like you want me dance like you need me-->
<!--                Cause I haven't had a bubble in a long long time-->
<!--                Baby come here, give me strong wine-->
<!--                I don't want wahala-->
<!--                I just want to holla-->
<!--                And spend money in Nevada-->
<!--                Then get faded in Jamaica-->
<!--                Dance on me like passa passa-->
<!--                Honey you a keeper-->
<!--                I think I want to keep you-->
<!--                But I don't want wahala-->
<!--                I don't want wahala-->
<!--                I just want to holla-->
<!--                And spend money in Nevada-->
<!--                Then get faded in Jamaica-->
<!--                Dance on me like passa passa-->
<!--                Honey you a keeper-->
<!--                I think I wanna keep you-->
<!--                But I don't want wahala-->
<!--                Do you want to go and get high with me smoke an L in the back of my subi-->
<!--                Oh why must it feel this smooth-->
<!--                Do you want to go and get high with me smoke an L in the back of the subi-->
<!--                Oh why must it feel this smooth-->
<!--                I don't want wahala-->
<!--                I just want to holla-->
<!--                And spend money in Nevada-->
<!--                Then get faded in Jamaica-->
<!--                Dance on me like passa passa-->
<!--                Honey you a keeper-->
<!--                I think I want to keep you-->
<!--                But I don't want wahala-->
<!--                I don't want wahala-->
<!--                I just want to holla-->
<!--                And spend money in Nevada-->
<!--                Then get faded in Jamaica-->
<!--                Dance on me like passa passa-->
<!--                Honey you a keeper-->
<!--                I think I want keep you-->
<!--                But I don't want wahala-->
<!--                I don't want problems-->
<!--                I don't want drama-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--        <div slot="footer" class="justify-content-center">-->
<!--&lt;!&ndash;          <n-button type="info" round @click.native="modals.notice = false">Sounds good!</n-button>&ndash;&gt;-->
<!--        </div>-->
<!--      </modal>-->
    </div>
<!--    <modal :show.sync="modals.login"-->
<!--           modal-classes="modal-login"-->
<!--           class="modal-login-chad">-->
<!--      <div class="card card-plain card-login" data-background-color="black" slot="base-content">-->
<!--        <div class="modal-header justify-content-center">-->
<!--          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">-->
<!--            <i class="now-ui-icons ui-1_simple-remove"></i>-->
<!--          </button>-->
<!--          <div class="header header-primary text-center">-->
<!--            <div class="logo-container">-->
<!--              <img v-lazy="'img/chad/chad-ashe-logo.png'" alt="">-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="modal-body">-->
<!--          <div class="form" v-on:keyup.enter="verifyCode">-->
<!--            <div class="card-body text-center">-->
<!--              <p>Enter your invitation code.</p>-->
<!--              <fg-input v-model="password"-->
<!--                        class="no-border input-lg"-->
<!--                        type="password"-->
<!--                        addon-left-icon="now-ui-icons ui-1_lock-circle-open"-->
<!--                        placeholder="Password...">-->
<!--              </fg-input>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="modal-footer text-center">-->
<!--          <span @click="verifyCode" class="btn btn-neutral btn-round btn-lg btn-block">Enter</span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </modal>-->
  </div>
</template>

<script>
  import { Card, InfoSection, FormGroupInput, Button, Alert, Modal } from '@/components';
  import { Carousel, CarouselItem, Tooltip } from 'element-ui'
  import { ValidationProvider, extend } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Countdown from 'vuejs-countdown'

  const querystring = require("querystring");

  extend('required', {
    ...required,
    message: 'This field is required'
  });

  export default {
    name: 'about',
    bodyClass: 'presentation-page',
    components: {
      Alert,
      Card,
      Countdown,
      Modal,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      ValidationProvider
    },
    created() {
      this.modals.login = true;
      this.validCode = false
    },
    data() {
      return {
        form: {
          fullName: '',
          email: '',
          phone: '',
          message: ''
        },
        modals: {
          notice: false,
          login: true
        },
        value: '',
        sent: false,
        password:'',
        validCode:false
      }
    },
    methods: {
      verifyCode() {
        if (this.password === '123'){
          this.modals.login = false;
          this.validCode = true;
        }

      },
      sendEmail(e) {
        // debugger
        console.log('Name is: ' + this.form.fullName)
        console.log('email is: ' + this.form.email)
        console.log('phone is: ' + this.form.phone)
        console.log('message is: ' + this.form.message)
        if(this.isValidForm)
        {
          e.preventDefault();
          this.$axios
              .post(
                  "https://sunkinginc.com/mail.php",
                  querystring.stringify(this.form)
              )
              .then(res => {
                this.sent = true;
              });
        }
        // debugger
        // console.log('Name is: ' + this.form.fullName)
        // console.log('email is: ' + this.form.email)
        // console.log('phone is: ' + this.form.phone)
        // console.log('message is: ' + this.form.message)
      },
      isValidEmail(email) {
        const re = /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      },
      isValidPhone(phone) {
        const re = /^$|^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        return re.test(String(phone).toLocaleLowerCase())
      },
      isValidMessage(message) {
        const re = /^(.{0,100})$/;
        return re.test(String(message).toLocaleLowerCase())
      },
      isValidForm() {
        // if(this.form.email && this.form.fullName && this.form.message && this.form.phone) {
        if(this.isValidEmail(this.form.email)
            && this.isValidMessage(this.form.message)
            && this.isValidEmail(this.form.phone)
            && this.form.fullName != ''
            && this.form.email    != ''
            && this.form.message  != '' ) {
          return true
        }
        else {
          return false
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    .github-buttons {
        display: flex;
        align-content: center;
    }
    .news-card{
      min-height: 300px;
      background-color: rgba(255, 255, 255, 0.5)
    }
    .news-card-img{
      margin-top: 20px;
      width: 70%;
      height: 100px;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }

    .snippet-img{
      max-height: 300px;
    }
    .snippet-icon{
      position:absolute;
      top:20%;
      left:20%;
    }

    .is-valid-code{
      filter: blur(15px);
      -webkit-filter: blur(15px);
    }
</style>
